import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { expandedRowFocus } from './BridgeMultiPoolTableEntryPool';

export type ExpandPoolButtonProps = Readonly<{
  isExpanded: boolean;
  setExpanded: (expand: boolean) => void;
  isDisabled: boolean;
}>;

export function ExpandPoolButton(props: ExpandPoolButtonProps) {
  const focusHighlight = props.isExpanded ? expandedRowFocus : '';
  return (
    <td className={`tb-data-grid-separator-row ${focusHighlight}`}>
      <span className={'tb-data-grid-icon tb-padded-left-large'} data-tb-test-id={'pool-expand-icon'}>
        <ButtonWidget
          buttonType={ButtonType.IconOutline}
          testId={'expand-pool-button'}
          onClick={() => props.setExpanded(!props.isExpanded)}
          disabled={props.isDisabled}
        >
          {props.isExpanded ?
            <img src={imgPath('arrow_chevron_up_14px-small.svg')} alt={Messages.collapse()} />
            :
            <img src={imgPath('arrow_chevron_down_14px-small.svg')} alt={Messages.expand()} />
          }
        </ButtonWidget>
      </span>
    </td>
  );
}
